import { render, staticRenderFns } from "./SkeletonAnimations.vue?vue&type=template&id=34748d2e"
import script from "./SkeletonAnimations.vue?vue&type=script&lang=js"
export * from "./SkeletonAnimations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports